var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { useCallback, useState } from 'react';

var useUpdate = function useUpdate() {
  var _a = __read(useState({}), 2),
      setState = _a[1];

  return useCallback(function () {
    return setState({});
  }, []);
};

export default useUpdate;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useUpdate/index.js
// module id = 7518
// module chunks = 2